import { FlexBox } from "@brg/ui";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import styled from "styled-components";

interface CheckLongreadRadioButtonProps {
  onChange: () => void;
  name: string;
  title: string;
  checked: boolean;
  disabled?: boolean;
  hintText?: string;
  hintPlace?: 'top' | 'right' | 'bottom' | 'left';
}

const RadioLabel = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  font-size: 15px;
  line-height: 20px;
  color: #909090;
  margin-bottom: 0px;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

const HiddenRadio = styled.input`
  display: none;
`;

const CustomRadio = styled.div<{ checked: boolean }>`
  width: 24px;
  height: 24px;
  border: 1px solid #909090;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::after {
    content: "";
    width: 6px;
    height: 6px;
    background-color: ${({ checked }) => (checked ? "#151514" : "transparent")};
    border-radius: 50%;
  }
`;

const TitleWrapper = styled(FlexBox)`
  .info-icon-wrapper {
    margin-left: 8px;
    width: 12px;
    height: 12px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

const CheckLongreadRadioButton: React.FC<CheckLongreadRadioButtonProps> = ({
  onChange,
  name,
  title,
  checked,
  disabled,
  hintText,
  hintPlace,
}) => {
  return (
    <RadioLabel className="radio-button--label" $disabled={disabled}>
      <HiddenRadio
        type="radio"
        name={name}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      <CustomRadio className="radio-button--custom-radio" checked={checked} />
      <TitleWrapper gx={8} gxMobile={8} align={'center'}>
        {title}
        {hintText && <InfoIcon stc msg={hintText} place={hintPlace} />}
      </TitleWrapper>
    </RadioLabel>
  );
};

export default CheckLongreadRadioButton;import { FlexBox } from "@brg/ui";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import styled from "styled-components";

interface CheckLongreadRadioButtonProps {
  onChange: () => void;
  name: string;
  title: string;
  checked: boolean;
  disabled?: boolean;
  hintText?: string;
  hintPlace?: 'top' | 'right' | 'bottom' | 'left';
}

const RadioLabel = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  font-size: 15px;
  line-height: 20px;
  color: #909090;
  margin-bottom: 0px;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

const HiddenRadio = styled.input`
  display: none;
`;

const CustomRadio = styled.div<{ checked: boolean }>`
  width: 24px;
  height: 24px;
  border: 1px solid #909090;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::after {
    content: "";
    width: 6px;
    height: 6px;
    background-color: ${({ checked }) => (checked ? "#151514" : "transparent")};
    border-radius: 50%;
  }
`;

const TitleWrapper = styled(FlexBox)`
  .info-icon-wrapper {
    margin-left: 8px;
    width: 12px;
    height: 12px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

const CheckLongreadRadioButton: React.FC<CheckLongreadRadioButtonProps> = ({
  onChange,
  name,
  title,
  checked,
  disabled,
  hintText,
  hintPlace,
}) => {
  return (
    <RadioLabel className="radio-button--label" $disabled={disabled}>
      <HiddenRadio
        type="radio"
        name={name}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      <CustomRadio className="radio-button--custom-radio" checked={checked} />
      <TitleWrapper gx={8} gxMobile={8} align={'center'}>
        {title}
        {hintText && <InfoIcon stc msg={hintText} place={hintPlace} />}
      </TitleWrapper>
    </RadioLabel>
  );
};

export default CheckLongreadRadioButton;